/* tslint:disable */
/* eslint-disable */
/**
 * Orders and payments
 * Placeholder description of the order & payment instruction service. Detailed description to be provided by Monavate team.
 *
 * The version of the OpenAPI document: 1.33.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Card-share type. Defaults to <code>merchant</code>. <code>individual</code> is only available for Mastercard cards when the client\'s card-share-with-individual setting is enabled, and cannot be changed after the card is created. Contact your account manager if you would like to enable card share for individual.
 * @export
 * @enum {string}
 */

export const CardShareType = {
    Merchant: 'merchant',
    Individual: 'individual'
} as const;

export type CardShareType = typeof CardShareType[keyof typeof CardShareType];



